import { render, staticRenderFns } from "./DialogServicePurchased.vue?vue&type=template&id=4f971b2d&scoped=true"
import script from "./DialogServicePurchased.vue?vue&type=script&lang=js"
export * from "./DialogServicePurchased.vue?vue&type=script&lang=js"
import style0 from "./css/common.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DialogServicePurchased.vue?vue&type=style&index=1&id=4f971b2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f971b2d",
  null
  
)

export default component.exports